export default "__VITE_PUBLIC_ASSET__1520fe31__"